<template>
  <div class="terms-content-overlay" @click.self="$emit('close')">
    <div class="terms-content-container">
      <div class="terms-content-header">
        <h2>ブクマす｜BKMS 利用規約</h2>
        <button class="close-button" @click="$emit('close')">×</button>
      </div>
      
      <div class="terms-content-body">
        <p>本利用規約（以下「本規約」）は、本サービスを提供する運営者（以下「当方」）が提供するブックマーク管理サービス（以下「本サービス」）の利用に関する条件を定めるものです。本サービスを利用される皆さま（以下「ユーザー」）は、本規約に同意いただいたうえで本サービスをご利用ください。</p>

        <h3>第1条（本サービスの内容）</h3>
        <ol>
          <li>本サービスは、ウェブ上でブックマークをタイル状に管理できる機能を提供するものです。ユーザーは登録フォームやドラッグ&ドロップ等のUIを通じてブックマークを追加・編集できます。</li>
          <li>本サービスは、基本的にローカルストレージ（Cookie・localStorage）を用いてユーザーデータを保存し、ユーザーのブラウザ環境内で完結して動作します。</li>
          <li>加えて、希望するユーザーはクラウド保存機能（Cloudflare KVサービス利用）を利用することで、複数のデバイス間でブックマークの同期・復元が可能です（クラウド保存は任意の機能です）。</li>
          <li>本サービスは、インターネット接続環境および対応ブラウザが必要です。ローカルストレージ利用時であっても一部機能では通信が発生する場合があります。</li>
          <li>本サービスには、広告表示、検索機能、JSON形式でのエクスポート・インポート機能などが含まれます。詳細な仕様は別途定義された要件定義書等をご確認ください。</li>
        </ol>

        <h3>第2条（規約への同意）</h3>
        <ol start="6">
          <li>ユーザーは、本サービスを利用することによって、本規約の内容に同意したものとみなします。</li>
          <li>ユーザーが未成年の場合、法定代理人の同意を得たうえで本サービスを利用してください。</li>
        </ol>

        <h3>第3条（規約の変更）</h3>
        <ol start="8">
          <li>当方は、必要に応じて本規約を変更することができます。変更後の規約は、本サービス上または当方が適当と判断する方法で告知された時点から効力を生じるものとします。</li>
          <li>規約変更後にユーザーが本サービスを継続して利用した場合、変更後の規約に同意したものとみなします。</li>
        </ol>

        <h3>第4条（アカウント・データ管理）</h3>
        <ol start="10">
          <li>本サービスでは、ユーザーデータ（ブックマーク、設定等）をブラウザのローカルストレージ（Cookie・localStorage）に保存します。</li>
          <li>さらに、クラウド保存機能を有効化した場合には、Cloudflare KVサービスを利用して暗号化されたユーザーデータが保存されます。クラウド保存されたデータは4桁のPINコードで保護されます。</li>
          <li>クラウド保存を利用するかどうかはユーザーが任意に選択可能であり、ローカルストレージのみでの利用も引き続き可能です。</li>
          <li>クラウド保存を利用する場合でも、データの完全な永続性は保証されず、定期的なバックアップやエクスポートはユーザー自身の責任で行ってください。</li>
          <li>通信障害やシステム障害等により、ユーザーデータが消失・破損する可能性があり、当方はこれに関して一切の責任を負いません。</li>
          <li>クラウド保存されたデータは、1年間アクセスがない場合、自動的に削除される場合があります。</li>
        </ol>

        <h3>第5条（禁止事項）</h3>
        <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはならないものとします。</p>
        <ol start="16">
          <li>法令または公序良俗に違反する行為</li>
          <li>犯罪行為や違法行為に結びつくおそれのある行為</li>
          <li>第三者または当方の権利・利益を侵害する行為（著作権、商標権、プライバシー等）</li>
          <li>他のユーザーや第三者に不利益または損害を与える行為</li>
          <li>本サービスの運営を妨害したり、システムやサーバに過度な負荷をかける行為</li>
          <li>本サービスの趣旨・目的から逸脱した方法での利用</li>
          <li>その他、当方が不適切と判断する行為</li>
        </ol>

        <h3>第6条（権利帰属）</h3>
        <ol start="23">
          <li>本サービスに関する著作権、商標権、その他の知的財産権は、当方または正当な権利を有する第三者に帰属します。</li>
          <li>本サービス上で提供されるコンテンツの著作権も同様とし、ユーザーは本規約で明示的に認められた範囲を超えて複製・改変等を行ってはなりません。</li>
        </ol>

        <h3>第7条（免責事項）</h3>
        <ol start="25">
          <li>当方は、本サービスおよびユーザーデータの正確性、完全性、有用性、安全性について一切保証いたしません。</li>
          <li>通信環境や外部サービス、ブラウザの設定等に起因して発生した不具合、データの消失・漏洩等について、当方は責任を負いません。</li>
          <li>広告・リンク先の外部サービスに関して生じた損害にも、当方は責任を負いません。</li>
          <li>本サービスは予告なく内容の変更・停止・終了を行う場合があり、これによる損害についても責任を負いません。</li>
        </ol>

        <h3>第8条（サービスの変更・中断・終了）</h3>
        <ol start="29">
          <li>当方は、定期または緊急の保守・障害対応のために、本サービスの全部または一部を変更・中断・終了することがあります。</li>
          <li>これによりユーザーに損害が生じた場合も、当方は責任を負いません。</li>
        </ol>

        <h3>第9条（個人情報の取り扱い）</h3>
        <ol start="31">
          <li>本サービスで取得するユーザーデータには、ブックマーク情報等のほか、ユーザーの入力に応じて個人情報が含まれる場合があります。</li>
          <li>取得した個人情報の取り扱いについては、当方が別途定めるプライバシーポリシーがある場合、それに従うものとします。</li>
        </ol>

        <h3>第10条（利用停止・登録削除）</h3>
        <ol start="33">
          <li>ユーザーが本規約に違反した場合、当方は該当ユーザーの利用を制限または停止し、必要に応じてデータ削除等の措置をとることがあります。</li>
        </ol>

        <h3>第11条（準拠法および管轄裁判所）</h3>
        <ol start="34">
          <li>本規約の解釈および適用には日本法を準拠法とします。</li>
          <li>本サービスに関して訴訟等の必要が生じた場合、当方の所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。</li>
        </ol>

        <h3>第12条（協議事項）</h3>
        <ol start="36">
          <li>本規約に定めのない事項や疑義が生じた場合は、ユーザーと当方が誠意をもって協議し、円満に解決を図るものとします。</li>
        </ol>
      </div>
      
      <div class="terms-content-buttons">
        <button class="close-button-bottom" @click="$emit('close')">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsContent'
}
</script>

<style scoped>
.terms-content-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200; /* TermsModalより上に表示 */
}

.terms-content-container {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.terms-content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.terms-content-header h2 {
  margin: 0;
  font-size: 1.3rem;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
}

.close-button:hover {
  color: #333;
}

.terms-content-body {
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
}

.terms-content-body h3 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  color: #333;
}

.terms-content-body p {
  margin-bottom: 1em;
  line-height: 1.6;
}

.terms-content-body ol {
  padding-left: 1.5em;
  margin-bottom: 1em;
}

.terms-content-body li {
  margin-bottom: 0.5em;
}

.terms-content-buttons {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  text-align: center;
}

.close-button-bottom {
  background-color: #e9d0ca;
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 8px 25px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.close-button-bottom:hover {
  background-color: #d9b6ab;
}
</style>